module.exports = __webpack_public_path__ + "assets/translate-arrow_icon.804eb19d.svg";